import React from 'react';
import Button from 'flow/components/ui-components/Button';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    disabled?: boolean;
    onClick: () => void;
}

const ButtonWhatsAppTemplateReply = ({ disabled, onClick }: Props) => {
    const { i18next } = useAppContext();
    return (
        <Button
            onClick={onClick}
            disabled={disabled}
            className={'bg-green text-white'}
        >
            {i18next.t('tickets.reply.template')}
        </Button>
    );
};

export default ButtonWhatsAppTemplateReply;
